import { Box, CardContent, Typography, FormControlLabel, Switch } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'TargetingResponseSettings.Title',
    defaultMessage: 'Response Settings',
  },
  subtitle: {
    id: 'TargetingResponseSettings.Subtitle',
    defaultMessage: 'Control how people can respond to your survey.',
  },
  preventMultipleResponses: {
    id: 'TargetingResponseSettings.PreventMultipleResponses',
    defaultMessage: 'Limit to 1 response per person',
  },
  preventMultipleResponsesDescription: {
    id: 'TargetingResponseSettings.PreventMultipleResponsesDescription',
    defaultMessage: 'Prevent the same person from responding multiple times to this survey.',
  },
});

function TargetingResponseSettings() {
  const { formatMessage } = useIntl();
  const { watch, setValue } = useFormContext();
  const preventMultipleResponses = watch('preventMultipleResponses');

  return (
    <CardContent
      sx={{
        borderWidth: 0,
        borderColor: 'muted.lighter',
        borderStyle: 'solid',
        borderTopWidth: 1,
      }}
    >
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
        {formatMessage(messages.subtitle)}
      </Typography>

      <Box sx={{ mb: 3 }}>
        <FormControlLabel
          control={
            <Switch
              checked={preventMultipleResponses}
              onChange={e => setValue('preventMultipleResponses', e.target.checked)}
            />
          }
          label={
            <Box>
              <Typography variant="body1">
                {formatMessage(messages.preventMultipleResponses)}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {formatMessage(messages.preventMultipleResponsesDescription)}
              </Typography>
            </Box>
          }
        />
      </Box>
    </CardContent>
  );
}

export default TargetingResponseSettings;
